import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { InstituteService } from 'src/app/Services/institute.service';
import { EmailVerificationPopupComponent } from '../register/email-verification-popup/email-verification-popup.component';
import { PidSelectInstituteComponent } from '../institute-register/pid-select-institute/pid-select-institute.component';
import { NonAicteRegisterPopupComponent } from './non-aicte-register-popup/non-aicte-register-popup.component';
import * as shajs from 'sha.js';

@Component({
  selector: 'app-institute-register',
  templateUrl: './institute-register.component.html',
  styleUrls: ['./institute-register.component.scss']
})
export class InstituteRegisterComponent implements OnInit {

  registerForm: FormGroup;
  aicteInstBool: boolean = false;
  // nonApprovedInst: boolean = false;
  aisheBool: boolean = false;
  states: any = [];
  district: any = [];
  instTypes: any = [];
  institutes: any = [
    { 'id': 1, 'organization_type': 'AICTE Approved Institute' },
    { 'id': 2, 'organization_type': 'AICTE Non-Approved Institute' }
  ];
  error: any;
  displayMssg: any;

  constructor(
    private register: InstituteService,
    public dialog: MatDialog,
    public fb: FormBuilder,
    public toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.displayMssg = 'case1';
    this.register.getState().subscribe(data => this.states = data['states']);
    this.register.getInstTypes().subscribe(data => this.instTypes = data['types'])
  }

  PIDSelect() {
    const dialogRef = this.dialog.open(PidSelectInstituteComponent, {
      height: '90%', width: 'auto'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.setInstituteValues(result['data']);
      }
    });
  }

  setInstituteValues(data) {
    this.registerForm.controls['institute_permanent_id'].setValue(data['PERMANENT_ID'])
    this.registerForm.controls['institute_name'].setValue(data['CURRENT_INSTITUTE_NAME'])
    this.registerForm.controls['institute_address'].setValue(data['CURRENT_INSTITUTE_ADDRESS'])
    this.registerForm.controls['inst_type'].setValue(data['INST_TYPE'])
    this.registerForm.controls['state'].setValue(data['INSTI_STATE'])
    this.registerForm.controls['city'].setValue(data['INSTITUTE_DISTRICT'])
    this.registerForm.controls['principalEmail'].setValue(data['HOI_EMAIL'])
    this.registerForm.controls['principalMobile'].setValue(data['HOI_CELL_NUMBER'])
  }

  createForm() {
    this.registerForm = this.fb.group({
      institute_type: ['', Validators.required],
      institute_permanent_id: [''],
      institute_name: ['', Validators.required],
      institute_address: ['', Validators.required],
      inst_type: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      principalEmail: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$')])],
      principalMobile: ['', Validators.compose([Validators.required, Validators.pattern('[56789][0-9]{9}')])],
      password: [null, Validators.compose([Validators.required, Validators.minLength(8), Validators.pattern('(?=^.{6,}$)(?=.*[0-9])(?![.\n])(?=.*[@!#$%^&*-+:;_=,.<>~`/()\\[\\{}])(?=.*[A-Z])(?=.*[a-z]).*$')])],
      confirmPassword: [null, Validators.compose([Validators.required, Validators.pattern('(?=^.{6,}$)(?=.*[0-9])(?![.\n])(?=.*[@!#$%^&*-+:;_=,.<>~`/()\\[\\{}])(?=.*[A-Z])(?=.*[a-z]).*$')])],
      aishe_code: [null]
    })
  }

  onInstituteChange(event) {
    this.registerForm.controls['institute_permanent_id'].setValue('');
    this.registerForm.controls['institute_name'].setValue('');
    this.registerForm.controls['institute_address'].setValue('');
    this.registerForm.controls['inst_type'].setValue('');
    this.registerForm.controls['state'].setValue('');
    this.registerForm.controls['city'].setValue('');
    this.registerForm.controls['principalEmail'].setValue('');
    this.registerForm.controls['principalMobile'].setValue('');
    this.registerForm.controls['principalMobile'].setValue('');
    this.registerForm.controls['aishe_code'].setValue('');
    if (event.value == 1) {
      this.aicteInstBool = true;
      this.displayMssg = 'case2';
    } else {
      this.aicteInstBool = false;
    }
    this.aisheBool = false;
  }

  onCodeSelection(event) {
    if(event.value == 'Yes') {
      this.aisheBool = true;
      this.registerForm.controls.inst_type.disable();
      this.registerForm.controls.aishe_code.enable();
      this.displayMssg = 'case3';
    } else {
      this.aisheBool = false;
      this.registerForm.controls.inst_type.enable();
      this.registerForm.controls.aishe_code.disable();
      this.displayMssg = 'case4';
    }
    
    this.resetValues();
  }

  onSelectState(event) {
    this.registerForm.controls['state'].setValue(event.value)
    this.register.getDistrict(event.value).subscribe(data => this.district = data['districts']);
  }

  checkNumber(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  getAisheDetails(){
    this.register.getAisheDetails(btoa(this.registerForm.controls.aishe_code.value)).subscribe(data=>this.setAisheDetails(data));
  }
  
  setAisheDetails(data){
    // console.log(data);
    if(data['type']=="Success"){
      var aisheDetails = data['data']['serviceResponse'];
      if(aisheDetails['response']){
        if(aisheDetails['response']['responseCode']!=200){
          this.toastr.error(aisheDetails['response']['responseMessage']+". "+aisheDetails['response']['responseDescription']);
          this.resetValues();
        }
      }
      if(aisheDetails['customResponse']){
        if(aisheDetails['customResponse']['responseCode']==200){
          if(aisheDetails['data'] =='No Data Found'){
            this.toastr.error('No Data Found');
            this.resetValues();
          }else if(aisheDetails['data'].length){
            var instituteDetails = aisheDetails['data']['0'];
            this.registerForm.controls.institute_name.setValue(instituteDetails['institutionName']);
            this.registerForm.controls.institute_address.setValue(instituteDetails['addressLine1']+", "+instituteDetails['addressLine2']);
            this.registerForm.controls.state.setValue(instituteDetails['state']);
            this.registerForm.controls.city.setValue(instituteDetails['district']);
            this.registerForm.controls.principalEmail.setValue(instituteDetails['headEmail'].trim());
            if(instituteDetails['headMobile']){
              if(instituteDetails['headMobile'].length>10){
                instituteDetails['headMobile'] = instituteDetails['headMobile'].replace(/^0+/, '');
              }
            }
            this.registerForm.controls.principalMobile.setValue(instituteDetails['headMobile']);
          }
        }else{
          this.toastr.error('No Data Found');
          this.resetValues();
        }
      }
    }
  }

  resetValues(){
    this.registerForm.controls['institute_permanent_id'].setValue('');
    this.registerForm.controls['institute_name'].setValue('');
    this.registerForm.controls['institute_address'].setValue('');
    this.registerForm.controls['inst_type'].setValue('');
    this.registerForm.controls['state'].setValue('');
    this.registerForm.controls['city'].setValue('');
    this.registerForm.controls['principalEmail'].setValue('');
    this.registerForm.controls['principalMobile'].setValue('');
    this.registerForm.controls['principalMobile'].setValue('');
    this.registerForm.controls['aishe_code'].setValue('');
    this.registerForm.controls['password'].setValue('');
    this.registerForm.controls['confirmPassword'].setValue('');
  }

  onSubmit(values) {
    if (this.registerForm.valid) {
      if (values.password == values.confirmPassword) {
        let tempEmail = this.registerForm.controls.principalEmail.value;
        let lowerCaseEmail = tempEmail.toLowerCase();
        let encryptedEmail = btoa(lowerCaseEmail);
        // let encryptedEmail = btoa(this.registerForm.controls.principalEmail.value);
        let encryptedPassword = shajs('sha512').update(this.registerForm.controls.password.value + encryptedEmail).digest('hex');
        values['password'] = encryptedPassword;
        values['confirmPassword'] = shajs('sha512').update(this.registerForm.controls.confirmPassword.value + encryptedEmail).digest('hex');
        values['principalEmail'] = encryptedEmail;
        this.register.registerInstitute(values).subscribe(
          response => this.handleResponse(response),
          error => this.handleError(error)
        );
      } else {
        this.toastr.error('Password confirmation does not match!');
      }
    } else {
      this.toastr.error('Kindly fill all the details');
    }
  }

  handleResponse(data) {
    if (data['type'] == 'Success') {
      this.verifyEmailPopup();
    }
    else {
      this.toastr.error(data['message']);
    }
  }

  handleError(error) {
    this.toastr.error(error.error.errors, 'Error!');
  }

  verifyEmailPopup() {
    if (this.registerForm.controls.institute_type.value == 1) {
      const dialogRef = this.dialog.open(EmailVerificationPopupComponent);
      dialogRef.afterClosed().subscribe((result) => {
        this.ngOnInit()
      });
    } else {
      const dialogRef = this.dialog.open(NonAicteRegisterPopupComponent);
      dialogRef.afterClosed().subscribe((result) => {
        this.ngOnInit()
      });
    }
  }

  isSpace(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode == 32) {
      return false;
    }
    return true;
  }

}
